import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { AgricolaMenuItem, AgricolaSubmenuItem } from '../../../interfaces/agricola.interface';
import { AuthService } from '../../../services/auth.service';
import { MeService } from '../../../services/me.service';

@Component({
  selector: 'app-agricola-navbar',
  templateUrl: './agricola-navbar.component.html',
  styleUrls: ['./agricola-navbar.component.css'],
  standalone: false
})
export class AgricolaNavbarComponent implements OnInit {

  @ViewChild('menuButton') menuButton?: ElementRef<HTMLButtonElement>;

  userName$: Observable<string>;
  menuOpen: boolean = false;
  userMenuOpen: boolean = false;
  sidebarWidth: number = 332;
  expandedItemTop: number = 0;

  menuItems: AgricolaMenuItem[] = [
    {
      label: 'Inicio',
      icon: 'assets/agricola/menu-home.svg',
      route: '/agricola',
      active: true,
      expanded: false
    },
    {
      label: 'Aperturas',
      icon: 'assets/agricola/menu-opciones.svg',
      active: false,
      expanded: false,
      submenu: [
        { label: 'Nueva venta', route: '/agricola/client-search' }
      ]
    },
    {
      label: 'Gestion y reportes',
      icon: 'assets/agricola/menu-opciones.svg',
      active: false,
      expanded: false,
      submenu: [
        { label: 'Reporte de ventas', route: '/agricola/reportes/ventas' },
        { label: 'Mis reportes', route: '/agricola/reportes/cola' }
      ]
    },
    {
      label: 'Consultas',
      icon: 'assets/agricola/menu-opciones.svg',
      active: false,
      expanded: false,
      submenu: [
        { label: 'Buscar póliza', route: '/agricola/policy-queries' }
      ]
    }
  ];

  constructor(
    private router: Router,
    private authService: AuthService,
    meService: MeService
  ) {
    this.userName$ = meService.currentUser$.pipe(
      map(user => user?.name || user?.email || 'Usuario')
    );
  }

  ngOnInit(): void {
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
    if (this.menuOpen) {
      this.userMenuOpen = false;
    }
  }

  toggleUserMenu(): void {
    this.userMenuOpen = !this.userMenuOpen;
    if (this.userMenuOpen) {
      this.closeSubmenu();
      this.menuOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.menuOpen) {
      this.closeAllMenus();
      this.menuButton?.nativeElement.focus();
    }
    this.userMenuOpen = false;
  }

  toggleSubmenu(item: AgricolaMenuItem, event: Event): void {
    event.stopPropagation();
    
    if (item.submenu && item.submenu.length > 0) {
      this.menuItems.forEach(menuItem => {
        if (menuItem !== item) {
          menuItem.expanded = false;
        }
      });
      item.expanded = !item.expanded;
      
      // Calculate the position of the expanded menu item
      if (item.expanded) {
        setTimeout(() => {
          const target = event.target as HTMLElement;
          const menuItemElement = target.closest('.menu-item') as HTMLElement;
          if (menuItemElement) {
            const sidebarElement = document.querySelector('.sidebar') as HTMLElement;
            if (sidebarElement) {
              const sidebarTop = sidebarElement.getBoundingClientRect().top;
              const itemTop = menuItemElement.getBoundingClientRect().top;
              this.expandedItemTop = itemTop - sidebarTop;
            }
          }
        }, 0);
      } else {
        this.expandedItemTop = 0;
      }
    } else {
      this.setActiveItem(item);
      if (item.route) {
        this.router.navigate([item.route]);
      }
      this.menuOpen = false;
    }
  }

  closeSubmenu(): void {
    this.menuItems.forEach(item => {
      item.expanded = false;
    });
    this.expandedItemTop = 0;
  }

  hasSubmenuOpen(): boolean {
    return this.menuItems.some(item => item.expanded && item.submenu && item.submenu.length > 0);
  }

  getExpandedItem(): AgricolaMenuItem | undefined {
    return this.menuItems.find(item => item.expanded && item.submenu && item.submenu.length > 0);
  }

  getExpandedSubmenu(): AgricolaSubmenuItem[] {
    return this.getExpandedItem()?.submenu || [];
  }

  closeAllMenus(): void {
    this.menuOpen = false;
    this.userMenuOpen = false;
    this.closeSubmenu();
    this.menuButton?.nativeElement.focus();
  }

  setActiveItem(activeItem: AgricolaMenuItem): void {
    this.menuItems.forEach(item => {
      item.active = item === activeItem;
    });
  }

  onSubmenuClick(subitem: AgricolaSubmenuItem, event: Event): void {
    event.stopPropagation();
    
    if (subitem.route) {
      this.router.navigate([subitem.route]);
    }
    
    if (subitem.action) {
      subitem.action();
    }
    
    this.menuOpen = false;
  }

  goHome(): void {
    this.closeAllMenus();
    const home = this.menuItems.find(item => item.route === '/agricola');
    if (home) {
      this.setActiveItem(home);
    }
    this.router.navigate(['/agricola']);
  }

  openQuickGuide(): void {
    window.open('https://storage.googleapis.com/policy-integrator-dev.appspot.com/s2_agricola/manual-Ventas-Asistencia-Agricola-SIS.pptx', '_blank');
  }

  logout(): void {
    this.userMenuOpen = false;
    this.authService.logout();
  }

}
